import { createListReducer } from 'app/redux/reducers/_reducer-factory/createListReducer';

const TEMPLATE_NAME = 'PROFESSION';

export default createListReducer(TEMPLATE_NAME);
